var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.291,
    height: 17.913,
    viewBox: "0 0 19.291 17.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M20.809,9.576H14.475L12.55,3.831a.7.7,0,0,0-1.309,0L9.316,9.576H2.939a.691.691,0,0,0-.689.689.506.506,0,0,0,.013.116.662.662,0,0,0,.289.487l5.206,3.669-2,5.809A.691.691,0,0,0,6,21.121a.666.666,0,0,0,.388.168.844.844,0,0,0,.431-.155L11.9,17.512l5.081,3.621a.807.807,0,0,0,.431.155.619.619,0,0,0,.383-.168.683.683,0,0,0,.237-.775l-2-5.809,5.163-3.7.125-.108a.722.722,0,0,0,.224-.461A.729.729,0,0,0,20.809,9.576Z",
    transform: "translate(-2.25 -3.375)",
    fill: "#dc3a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeReview);
export default __webpack_public_path__ + "static/media/orange-review.181527d5aa84acd007923884f97a8fc4.svg";
export { ForwardRef as ReactComponent };